import type { ItemAttributes, ItemNames } from '@ps-smart-cp/ppfw-client';
import { Characters, ItemName, Locale } from '@ps-smart-cp/ppfw-client';

interface Schema {
  previousPassword: string;
  newPassword: string;
  confirmedNewPassword: string;
}

const attributes = {
  previousPassword: Characters.preset.freeFormat({ maxLen: 256, required: true }),
  newPassword: Characters.preset.freeFormat({ maxLen: 256, required: true }),
  confirmedNewPassword: Characters.preset.freeFormat({ maxLen: 256, required: true }),
} satisfies ItemAttributes<Schema>;

const names = {
  previousPassword: ItemName.of([Locale.ja, '古いパスワード'], [Locale.en, 'Previous Password']),
  newPassword: ItemName.of([Locale.ja, '新しいパスワード'], [Locale.en, 'New Password']),
  confirmedNewPassword: ItemName.of(
    [Locale.ja, '新しいパスワード(確認用)'],
    [Locale.en, 'Confirmed New Password'],
  ),
} satisfies ItemNames<Schema>;

const titleNames = {
  changePassword: ItemName.of([Locale.ja, 'パスワード変更'], [Locale.en, 'Change Password']),
  firstTimeChangePassword: ItemName.of(
    [Locale.ja, '初回パスワード変更'],
    [Locale.en, 'First Time Change Password'],
  ),
};

const changePassword = {
  attributes,
  names,
  titleNames,
};

interface ChangePassword {
  schema: Schema;
}

export type { ChangePassword };
export { changePassword };
